export const POLLING_SUCCESS = "SUCCESS";
export const POLLING_PENDING = "PENDING";
export const POLLING_FAIL = "FAIL"